import { ArrowForwardIosSharp } from '@mui/icons-material';
import {
  AccordionDetails,
  AccordionSummary,
  Accordion as BaseAccordion,
  styled,
} from '@mui/material';

const Accordion = styled(BaseAccordion)({
  '&.Mui-expanded': {
    margin: 0,
  },
  background: 'none',
  border: 'none',
});

const Summary = styled(AccordionSummary)(({ theme }) => ({
  '&.Mui-expanded': {
    minHeight: 'auto',
  },
  '.MuiAccordionSummary-contentGutters': {
    '&.Mui-expanded': {
      margin: 0,
    },
    margin: 0,
  },
  '.MuiAccordionSummary-expandIconWrapper': {
    '&.Mui-expanded': {
      transform: 'rotate(90deg)',
    },
    marginRight: theme.spacing(1),
  },
  flexDirection: 'row-reverse',
  minHeight: 'auto',
}));

const Detail = styled(AccordionDetails)(({ theme }) => ({
  padding: theme.spacing(1, 0),
}));

const ExpandIcon = () => <ArrowForwardIosSharp sx={{ fontSize: '0.9rem' }} />;

type Props = {
  className?: string;
  style?: React.CSSProperties;
  title: React.ReactNode;
};

export const Details: React.FC<Props> = ({ children, className, style, title }) => (
  <Accordion className={className} style={style}>
    <Summary expandIcon={<ExpandIcon />}>{title}</Summary>
    <Detail>{children}</Detail>
  </Accordion>
);
